module.exports = __webpack_public_path__ + "static/media/mypicture.ba49be88.jpeg";